export default __webpack_public_path__ + "static/media/coin_ampl.65751840.svg";